import { useState, useEffect } from 'react'

import { Button, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Route } from 'react-router-dom'

import { useProject } from '../../api/project'
import { useCreateSalesStartSignup } from '../../api/signup'
import { useSignup } from '../../context/signup'
import { useSnackbar } from '../../context/snackbar'
import { useProjectId } from '../../hooks/useProjectId'
import { HtmlConnected as Html } from '../html'
import { Countdown } from './countdown'
import { DocVisible } from './docVisible'

export const StartPage = () => {
  const { t } = useTranslation()
  const { mergeUser, nextPage } = useSignup()
  const { showMessage } = useSnackbar()
  const projectId = useProjectId()
  const { data: project } = useProject(projectId)
  const [opensIn, setOpensIn] = useState(project?.signupOpenInMillis)
  const { mutate: createSalesStartSignup, isPending: loading } =
    useCreateSalesStartSignup()

  useEffect(() => {
    const THROTTLE_AMOUNT = 450
    const interval = setInterval(() => {
      if (opensIn <= 0) {
        clearInterval(interval)
      } else {
        setOpensIn(opensIn - THROTTLE_AMOUNT)
      }
    }, THROTTLE_AMOUNT)
    return () => clearInterval(interval)
  }, [opensIn])

  useEffect(() => {
    const interval = setInterval(() => {
      if (opensIn <= 0) {
        clearInterval(interval)
      } else {
        fetch(`/api/user/projects/${projectId}/time`)
          .then((res) => res.json())
          .then((data) => {
            setOpensIn(data.opensIn)
          })
      }
    }, 15000)
    return () => clearInterval(interval)
  }, [])

  const handleClickSignup = () =>
    createSalesStartSignup(
      { projectId: Number(projectId) },
      {
        onSuccess: (data) => {
          mergeUser({ ...data, signupType: 'SALES_START' })
          nextPage()
        },
        onError: (error) => showMessage(error.message),
      }
    )

  return (
    <>
      <Route path="/projekt/:projectId" component={DocVisible} />
      <Stack spacing={3}>
        <Html name="signup-start-heading" />
        <Stack direction="row" justifyContent="center">
          {opensIn > 0 ? (
            <Countdown milliseconds={opensIn} />
          ) : (
            <Button
              variant="contained"
              onClick={handleClickSignup}
              loading={loading}
              style={{ width: 110 }}
            >
              {t('Continue')}
            </Button>
          )}
        </Stack>
        <Html name="signup-start-body" />
      </Stack>
    </>
  )
}
